import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {PrimeNgModule} from '@app/shared/modules/prime-ng/prime-ng.module';
import {EffectsModule} from '@ngrx/effects';
import {SharedModule} from '../shared/shared.module';
import {MyOrdersComponent} from './components/my-orders/my-orders.component';
import {OrderDetailsComponent} from './components/order-details/order-details.component';
import {MyOrderEffects} from './components/state/my-order.effects';

@NgModule({
  imports: [
    RouterModule,
    FormsModule,
    SharedModule,
    PrimeNgModule,
    EffectsModule.forFeature([MyOrderEffects]),
    MyOrdersComponent,
    OrderDetailsComponent,
  ],
})
export class OrderModule {}
